import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchPrescriptionMeasures(lensId, frameId, singleVisionType) {
    switch (singleVisionType) {
        case "Distance":
            singleVisionType = 0;
            break;
        case "Readers":
            singleVisionType = 1;
            break;
        case "Intermediate":
            singleVisionType = 2;
            break;
        default:
            singleVisionType = 1;
            break;
    }

    let url = `/EyeTicketProcessing/GetStandardPrescriptionMeasures/${encodeURIComponent(lensId)}/${encodeURIComponent(frameId)}/${encodeURIComponent(singleVisionType)}`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Prescription Measures found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Prescription Measures : ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchCoatsAndTintsForLens(eyeTicketId, lensId, noOverrideTints = true, noOverrideCoats = true) {
    let url = `/EyeTicketProcessing/GetEyeTicketApprovedCoatsTintsAndCases/${encodeURIComponent(eyeTicketId)}/${encodeURIComponent(lensId)}?lAuthorisedTints=${encodeURIComponent(noOverrideTints)}&lAuthorisedCoats=${encodeURIComponent(noOverrideCoats)}`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Coats or Tints found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Coats and Tints : ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchLensBrand(eyeTicketId, frameId, lensType, noOverride = true) {
    let url = `/EyeTicketProcessing/GetEyeTicketLensBrand/${encodeURIComponent(eyeTicketId)}/${encodeURIComponent(frameId)}?cSelectedLensType=${encodeURIComponent(lensType)}&lLensStandard=${encodeURIComponent(noOverride)}`;

    if(!noOverride)
        {
            url += "&lEyeTicketOveride=true"
        }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Lens Brand found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Lens Brand: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchAllowedLensDropDownSelections(eyeTicketId, frameId, override = false) {
    let url = `/EyeTicketProcessing/GetEyeTicketLensDropDownSelection/${encodeURIComponent(eyeTicketId)}/${encodeURIComponent(frameId)}`;

    if(override)
    {
        url += "?IsLensOverrideRequired=true"
    }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Lens Options found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Lens Options: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchApprovedFrames(iEyeTicketID = null, override = false) {
    let url = `/EyeTicketProcessing/GetEyeTicketFramesList/200/1`;

    if (iEyeTicketID || override) {
        url += '?';

        if (iEyeTicketID) {
            url += `iEyeTicketID=${encodeURIComponent(iEyeTicketID)}`;
        }

        if (override) {
            if (iEyeTicketID) {
                url += '&';
            }
            url += `IsFrameOverrideRequired=${encodeURIComponent(override)}`;
        }
    }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Frames found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Frames: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function processEyeTicket(eyeTicket) {
    const url = `/EyeTicketProcessing/CompleteEyeTicketOrder`;

    try {
        const response = await buildRequest(url, 'POST', eyeTicket);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to process EyeTicket: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to process EyeTicket: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}